import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import MailAccountsListView from "./mail_accounts-list.html";
import MailAccountsEditView from "./mail_accounts-edit.html";


angular.module("mail_accounts", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('mail_accounts', {
                url: "/mail_accounts",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('mail_accounts.list', {
                url: "/list",
                controller: "MailAccountsListCtrl",
                template: MailAccountsListView,
                cache: false,
                requiredPermission: ["MAIL_ACCOUNTS_READ"]
            })            
            .state('mail_accounts.edit', {
                url: "/edit/:id",
                controller: "MailAccountsEditCtrl",
                template: MailAccountsEditView,
                cache: false,
                requiredPermission: ["MAIL_ACCOUNTS_READ"]
            })
    }])
;